import {
  DASHBOARDELEMIDS,
  TpDashboardCreationContext,
  TpDashboardElement,
  TpDashboardHorizontalLayoutDefinition,
  TpDashboardVerticalLayoutDefinition,
  TpStaticTextDefinition,
  TpDashboardSequenceLayoutDefinition,
} from './interfaces';

export interface TpElementLayoutHints {
  sizeXRelative?: number;
  sizeXAbsolute?: number;
  sizeYRelative?: number;
  sizeYAbsolute?: number;
}

/** Default relative size/fraction for horizontal and vertical layout elements. */
export const DEFAULT_LAYOUT_FRACTION = 1;

/** Default height in pixels for layout elements when not explicitly specified. */
export const DEFAULT_LAYOUT_HEIGHT = 500;

/** Default height in pixels when adding a new vertical layout via edit mode. */
export const DEFAULT_VERTICAL_LAYOUT_HEIGHT = 400;

/** Default height in pixels when adding a new chart widget via edit mode. */
export const DEFAULT_CHART_HEIGHT = 550;

/** Default column count for gallery layout elements. */
export const DEFAULT_GALLERY_COLUMN_COUNT = 4;

/** Default padding in pixels between dashboard widgets. */
export const DEFAULT_DASHBOARD_WIDGET_PADDING = 30;

export const dashboardWidgetPadding = DEFAULT_DASHBOARD_WIDGET_PADDING;

export function getLayoutInHorGroupRelative(fraction?: number, height?: number): TpElementLayoutHints {
  return {
    sizeXRelative: fraction || DEFAULT_LAYOUT_FRACTION,
    sizeYAbsolute: height || DEFAULT_LAYOUT_HEIGHT,
  };
}

export function getLayoutInVertGroupRelative(fraction?: number): TpElementLayoutHints {
  return {
    sizeYRelative: fraction || DEFAULT_LAYOUT_FRACTION,
  };
}

export function createHorizontalLayout(
  ctx: TpDashboardCreationContext,
  id: string,
  elements: TpDashboardElement[],
): TpDashboardHorizontalLayoutDefinition {
  return {
    elemType: DASHBOARDELEMIDS.HorizontalLayout,
    id,
    elemLayoutHints: getLayoutInHorGroupRelative(DEFAULT_LAYOUT_FRACTION),
    elements,
  };
}

export function createVerticalLayout(
  ctx: TpDashboardCreationContext,
  id: string,
  elements: TpDashboardElement[],
  horizontalSizeFraction: number,
  verticalSize?: number,
): TpDashboardVerticalLayoutDefinition {
  return {
    elemType: DASHBOARDELEMIDS.VerticalLayout,
    id,
    elemLayoutHints: {
      sizeXRelative: horizontalSizeFraction || DEFAULT_LAYOUT_FRACTION,
      sizeYAbsolute: verticalSize,
    },
    elements,
  };
}

export function createSequenceLayout(
  ctx: TpDashboardCreationContext | null,
  id: string,
  elements: TpDashboardElement[],
): TpDashboardSequenceLayoutDefinition {
  return {
    elemType: DASHBOARDELEMIDS.SequenceLayout,
    id,
    elemLayoutHints: getLayoutInHorGroupRelative(DEFAULT_LAYOUT_FRACTION),
    elements,
  };
}

export function createStaticText(ctx: TpDashboardCreationContext, id: string, content: string): TpStaticTextDefinition {
  return {
    elemType: DASHBOARDELEMIDS.StaticText,
    id,
    content,
  };
}
